/**
 * Configuration for localization resources.
 * This file maps locales to their respective translation files and provides a method
 * to dynamically load translations based on the requested locale.
 */

// Mapping of locales to their relative paths.
const config = {
  az: "az",
  en: "en",
  nl: "nl",
  ar: "ar",
  ja: "ja",
  de: "de",
  es: "es",
  fr: "fr",
  it: "it",
  ko: "ko",
  pt: "pt",
  tr: "tr",
  uk: "uk",
  vi: "vi",
  zh: "zh",
  zu: "zu",
  };
  
  /**
   * Dynamically fetches the translation for the given locale.
   *
   * @param {string} locale - The desired locale for translations.
   * @returns {Promise<object>} - A promise that resolves with the locale and its messages.
   */
  export const fetchTranslations = async (locale) => {
    // Check if the provided locale is available in the config resources. If not, default to English.
    const availableLocale = config[locale] ? locale : "en";
    // Dynamically import the required translation file.
    const messages = await import(`./${config[availableLocale]}/translation.json`);
    return messages;
  };
  
